var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"fui-app__bg"},[_c('b-container',{staticClass:"container",attrs:{"id":"app"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }